var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50506 11.4144L12.6161 4.30329C13.7877 3.13172 15.6872 3.13172 16.8588 4.30329L19.6872 7.13172C20.8588 8.30329 20.8588 10.2028 19.6872 11.3744L12.5761 18.4855M5.50506 11.4144L3.37669 13.5427C2.59565 14.3238 2.59565 15.5901 3.37669 16.3712L5.6816 18.6761C6.06667 19.0611 6.58925 19.2774 7.13396 19.2774H12.5761M5.50506 11.4144L12.5761 18.4855M12.5761 18.4855H21.4999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.65c43baaa73538fc751806a280ecba21.svg";
export { ForwardRef as ReactComponent };